<template>
	<div
		v-for="item in adSpaces"
		:key="item.index"
		class="mb-2 relative max-lg:hidden"
		:style="`height: ${item.height}px`"
	>
		<div class="sticky top-24">
			<Click
				:key="`click-${item.index}`"
				:placement="item.index % 2 === 0
					? AdPosition.ACTION_OFFER_LEAFLET_FIRST
					: AdPosition.ACTION_OFFER_LEAFLET_SECOND"
				class="!justify-start"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {AdPosition} from '~/openapi';

	interface Props {
		adSpaces: Array<{index: number; height: number}>;
	}

	defineProps<Props>();
</script>
